import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';

import { App } from '@/App';
import { AuthProvider } from '@/contexts/AuthContext';
import '../global.css';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: { staleTime: 60 * 1000, gcTime: 5 * 60 * 1000, retry: 1 },
	},
});

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<BrowserRouter>
			<QueryClientProvider client={queryClient}>
				<AuthProvider>
					<App />
					<Toaster theme="dark" position="top-right" />
				</AuthProvider>
			</QueryClientProvider>
		</BrowserRouter>
	</StrictMode>,
);
